import { render, staticRenderFns } from "./InvoiceForeignTrade.vue?vue&type=template&id=62113f9c&"
import script from "./InvoiceForeignTrade.vue?vue&type=script&lang=js&"
export * from "./InvoiceForeignTrade.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceForeignTrade.vue?vue&type=style&index=0&id=62113f9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports